import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useCallback } from 'react';
import cn from 'classnames';
import { useBiAction } from '../BiTracking';
import classes from './ChipButton.module.scss';
export const ChipButton = /*#__PURE__*/ forwardRef(function ChipButton(props, ref) {
    const { className, suffixIcon, children, highlight, disabled, variant, skin, testId, bi, noBi: _noBi, onClick } = props, rest = _object_without_properties(props, [
        "className",
        "suffixIcon",
        "children",
        "highlight",
        "disabled",
        "variant",
        "skin",
        "testId",
        "bi",
        "noBi",
        "onClick"
    ]);
    const logBiAction = useBiAction();
    const handleClick = useCallback((event)=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'chip_button',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        return onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        bi,
        logBiAction,
        onClick,
        testId
    ]);
    return /*#__PURE__*/ _jsxs("button", _object_spread_props(_object_spread({
        type: "button",
        ref: ref,
        disabled: disabled,
        className: cn(classes.root, className, {
            [classes.highlight]: highlight,
            [classes.fullWidth]: variant === 'fullWidth',
            [classes.ghost]: skin === 'ghost'
        }),
        "data-testid": testId,
        onClick: handleClick
    }, rest), {
        children: [
            children,
            suffixIcon ? /*#__PURE__*/ _jsx("div", {
                className: classes.suffixIcon,
                children: suffixIcon
            }) : null
        ]
    }));
});
